import { CardHeader, styled, Box, CardHeaderProps } from "@mui/material";
import React from "react";

interface HeaderProps extends CardHeaderProps {
    helperIcon?: React.ReactNode; 
}

export const Header = styled(({ helperIcon, ...props }: HeaderProps) => (
    <CardHeader
        {...props}
        action={helperIcon && (
            <Box display="flex" alignItems="center">
                {helperIcon}
            </Box>
        )}
    />
))(({ theme }) => ({
    padding: "8px",
    paddingLeft: "10px",
    "& .MuiCardHeader-title": {
        color: "var(--card-header-text-color)",
    },
}));
